import { Pipe, PipeTransform } from "@angular/core";
import { WalletConfig } from "../../services/api";

@Pipe({
  name: "balanceName",
  standalone: false,
})
export class BalanceNamePipe implements PipeTransform {
  public transform(balance: number = 2, walletConfig: WalletConfig | null | undefined, type: "balance" | "tierBalance" = "balance"): string {
    if (!walletConfig) return "";
    const absoluteBalance = Math.abs(balance);

    if (type === "balance") {
      const singular = walletConfig.singularBalanceName || walletConfig.balanceName;
      if (absoluteBalance === 1) return singular;
      return walletConfig.balanceName;
    }

    if (type === "tierBalance") {
      const singularTier = walletConfig.singularTierBalanceName || walletConfig.tierBalanceName;
      if (absoluteBalance === 1) return singularTier;
      return walletConfig.tierBalanceName;
    }

    return walletConfig.balanceName;
  }
}

